"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var PlannerSorting;
(function (PlannerSorting) {
    PlannerSorting["NEWEST"] = "newest";
    PlannerSorting["OLDEST"] = "oldest";
    PlannerSorting["ALPHABETICAL"] = "alphabetical";
})(PlannerSorting = exports.PlannerSorting || (exports.PlannerSorting = {}));
//# sourceMappingURL=PlannerSorting.js.map